import axios from 'axios';
import { getAuth } from './dev-auth';
import { requestInterceptor } from './interceptors/interceptors';
import { getBlazemeterAnalyticsUrl } from '../utils/bzmUserConfigUtil';
import store from '../store/configureStore';
import { BlazeUserConfigState } from '../store/blazeUserConfig/blazeUserConfigTypes';

/**
 * Reads analytics endpoint url from the user config.
 */
export const getAnalyticsEndpointBaseUrl = () => {
  const bzmConfig = (store.getState() as any).blazeUserConfig as BlazeUserConfigState;
  return getBlazemeterAnalyticsUrl(bzmConfig.blazeUserConfig);
};

const instance = axios.create({
  baseURL: 'https://analytics.blazemeter.com/', //Base URL is overwritten in this instance when blazeUsrConfig is loaded
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  auth: getAuth(),
  withCredentials: true,
});

instance.defaults.withXSRFToken = true;

//Request interceptor
instance.interceptors.request.use(
  request => {
    return requestInterceptor(request);
  },
  error => {
    return Promise.reject(error);
  },
);

export default instance;
